/**
 * Estrellas — las ★ de una puntuación, en las maquetas de Automatizaciones y
 * del Widget de reseñas.
 *
 * El diseño las escribe como texto (`'★★★★★'.slice(0, n) + '☆☆☆☆☆'...`). Eso
 * funciona hasta que lo lee un lector de pantalla, que dice «estrella negra
 * estrella negra estrella negra estrella blanca estrella blanca» — cinco veces
 * por tarjeta. Aquí las ★ van ocultas y al lado va la puntuación en palabras.
 *
 * `etiqueta` recibe el texto ya formado («4 de 5 estrellas») porque este
 * componente no traduce: el copy vive en el módulo de contenido.
 */
export default function Estrellas({ n, total = 5, etiqueta, className = '' }) {
  return (
    <span className={className}>
      <span aria-hidden="true" className="text-v3-gold tracking-[.5px]">
        {'★'.repeat(n)}
        <span className="text-v3-track">{'★'.repeat(Math.max(0, total - n))}</span>
      </span>
      {etiqueta ? <span className="sr-only">{etiqueta}</span> : null}
    </span>
  );
}
